export default "__VITE_ASSET__8ebbc5a3__"